<script setup lang="ts">
import { ref } from "vue";
import { useApiClient } from "@/api/client";
import ScreenDO = Modules.CampaignPlanner.Data.ScreenDO;
import FlightDO = Modules.CampaignPlanner.Data.FlightDO;

const props = defineProps<{
	flight: FlightDO;
}>();

const emit = defineEmits<{
	imported: [screens: ScreenDO[]];
}>();

const isVisible = defineModel<boolean>({ required: true });

const file = ref<File[]>([]);
const importing = ref(false);

const close = () => {
	isVisible.value = false;
	file.value = [];
};

const upload = async () => {
	if (!file.value[0]) return;

	importing.value = true;
	const result = await useApiClient(
		"campaignPlanner"
	).importScreenSelectionFromCsv(props.flight, file.value[0]);
	importing.value = false;

	if (result.isOk()) {
		console.log(result.value);
		emit("imported", result.value);
		close();
	}
};
</script>

<template>
	<v-dialog v-model="isVisible" max-width="520" persistent>
		<v-card>
			<v-toolbar color="lightprimary" elevation="0" flat>
				<template #prepend>
					<v-icon class="ml-3">fa: fa-regular fa-file-csv</v-icon>
				</template>
				<v-toolbar-title>Import selection from CSV</v-toolbar-title>
				<template #append>
					<v-btn icon variant="text" :disabled="importing" @click="close">
						<v-icon>fa: fa-regular fa-xmark</v-icon>
					</v-btn>
				</template>
			</v-toolbar>

			<v-divider />

			<v-card-text class="pa-6">
				<v-file-upload
					title="Drag and Drop Here"
					v-model="file"
					accept=".csv"
					:multiple="false"
				/>
				<div class="text-caption mt-3">
					* Please ensure the file is a .csv generated by Broadsign to align
					internal IDs correctly and achieve the intended results.
				</div>
			</v-card-text>

			<v-divider />

			<v-card-actions class="pa-4 justify-end gap-2">
				<v-btn variant="text" :disabled="importing" @click="close"
					>Cancel</v-btn
				>
				<v-btn
					color="primary"
					variant="flat"
					:disabled="file.length === 0"
					:loading="importing"
					@click="upload"
					>Upload</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
